export default __webpack_public_path__ + "static/media/laugh2.35dac6dd.gif";